/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelOrderPlanningProfile.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/order-planning-profile";

export class AutogenModelOrderPlanningProfile<RowType extends ModelRow> extends Endpoint<RowType, RowOrderPlanningProfileFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowOrderPlanningProfile extends ModelRow<RowOrderPlanningProfileFields> {
	constructor(values?: Partial<RowOrderPlanningProfileFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowOrderPlanningProfileFields {
	avail_tractor: string;
	calendar_days: number;
	calendar_end_web: string;
	calendar_ending: string;
	calendar_interval: string;
	calendar_start_web: string;
	calendar_zoom: number;
	calendar_zoom_web: number;
	company_id: string;
	default_view: string;
	driver_active_status: string;
	driver_manager: string;
	driver_manager_exclude: string;
	exclude_miles: number;
	id: string;
	include_on_hold_manifests: string;
	include_on_hold_orders: string;
    include_on_hold_manifests: string;
	include_reserved: string;
	local_tractor: string;
	mileage_server: string;
	movement_type: string;
	ops_status: string;
	order_asmt_filter: string;
	order_companies: string;
	order_companies_exclude: string;
	order_customers: string;
	order_customers_exclude: string;
	order_days: number;
	order_driver_manager: string;
	order_driver_manager_x: string;
	order_drvr_filter: string;
	order_error_filter: string;
	order_gridconfig: string;
	order_ib_type: string;
	order_ib_zones: string;
	order_ib_zones_exclude: string;
	order_include_accepted: string;
	order_late_only: string;
	order_late_status: string;
	order_late_status_exclude: string;
	order_load_filter: string;
	order_move_filter: string;
	order_ob_type: string;
	order_ob_zones: string;
	order_ob_zones_exclude: string;
	order_resp_codes: string;
	order_resp_codes_exclude: string;
	order_resp_level: number;
	order_tractor_fleet_id: string;
	order_tractor_fleet_id_x: string;
	order_trlr_type: string;
	order_trlr_type_exclude: string;
	order_type: string;
	order_type_exclude: string;
	preass_order: string;
	preass_tractor: string;
	profile_color: string;
	revenue_code: string;
	revenue_code_exclude: string;
	rikn_tl_group: string;
	show_broker_moves: string;
	show_ltl_orders: string;
	show_teams: string;
	start_day: string;
	title: string;
	tract_asmt_filter: string;
	tract_drvr_filter: string;
	tract_error_filter: string;
	tract_load_filter: string;
	tract_move_filter: string;
	tractor_companies: string;
	tractor_companies_exclude: string;
	tractor_customers: string;
	tractor_customers_exclude: string;
	tractor_days: number;
	tractor_fleet: string;
	tractor_fleet_exclude: string;
	tractor_gridconfig: string;
	tractor_ib_type: string;
	tractor_ib_zones: string;
	tractor_ib_zones_exclude: string;
	tractor_late_oor: string;
	tractor_latestatus: string;
	tractor_latestatus_exclude: string;
	tractor_ob_type: string;
	tractor_ob_zones: string;
	tractor_ob_zones_exclude: string;
	tractor_or_driver: string;
	tractor_resp_codes: string;
	tractor_resp_codes_exclude: string;
	tractor_resp_level: number;
	tractor_trlr_type: string;
	tractor_trlr_type_exclude: string;
	tractor_types: string;
	tractor_types_exclude: string;
	use_preassign_dest: string;
}

